export type SeasonsTabId = 'saison' | 'qualif' | 'replays';

/** Ancien onglet historique — accepté en lecture seule pour les deep-links. */
type LegacySeasonsTabId = SeasonsTabId | 'historique';

export function parseSeasonsTabFromHash(): SeasonsTabId {
  const raw = window.location.hash.replace(/^#/, '');
  if (!raw.startsWith('saisons')) return 'saison';
  const q = raw.indexOf('?');
  if (q < 0) return 'saison';
  const params = new URLSearchParams(raw.slice(q + 1));
  const tab = params.get('tab') as LegacySeasonsTabId | null;
  if (tab === 'replays' || tab === 'qualif') return tab;
  // historique (legacy) et campaign= s’affichent dans le panneau saison
  return 'saison';
}

export function seasonsTabHash(tab: SeasonsTabId): string {
  return tab === 'saison' ? 'saisons' : `saisons?tab=${tab}`;
}

export function seasonsCampaignHash(campaignKey: string): string {
  return `saisons?campaign=${encodeURIComponent(campaignKey)}`;
}

export function parseCampaignKeyFromHash(): string | null {
  const raw = window.location.hash.replace(/^#/, '');
  const qIndex = raw.indexOf('?');
  if (qIndex < 0) return null;
  const params = new URLSearchParams(raw.slice(qIndex + 1));
  return params.get('campaign');
}
